// One card in the library. It used to be 160 lines of inline `sx`, pasted
// twice into Home.js -- once for the featured rail and once for every
// category -- which is why the two had already stopped matching.
//
// What the resting card shows: the artwork, the title, what it is, and how far
// in you are. Everything else (description, play affordance) arrives on hover,
// so a rail of twelve reads as twelve pieces of artwork rather than twelve
// competing overlays.

import React from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import chatrobo from './chatrobo5.png';
import { hasVideoChat } from './videoChat';

export function VideoCard({ video, progress = 0, onOpen }) {
  const watched = progress > 95;
  const locked = !video.owned;
  const unlockWith = video.unlockWith || video.products;

  return (
    <button
      type="button"
      className={`learn-card${locked ? ' is-locked' : ''}`}
      aria-label={locked ? `${video.title} — locked` : `Play ${video.title}`}
      onClick={() => !locked && onOpen(video)}
    >
      <div className="learn-card__frame">
        {video.minithumbnailUrl && (
          <img
            className="learn-card__img"
            src={video.minithumbnailUrl}
            alt=""
            loading="lazy"
            decoding="async"
            width="232"
            height="290"
            onError={(e) => { e.target.style.visibility = 'hidden'; }}
          />
        )}

        {video.description && !locked && (
          <div className="learn-card__desc"><span>{video.description}</span></div>
        )}

        <div className="learn-card__veil" />

        <div className="learn-card__body">
          <span className="learn-card__title">{video.title}</span>
          <span className="learn-card__meta">
            {watched && <span style={{ color: 'var(--ps-gold)', fontSize: 10, lineHeight: 1 }}>✓</span>}
            <span className="ps-label ps-label--dim">
              {watched ? 'WATCHED' : video.category || ''}
            </span>
          </span>
        </div>

        {progress > 0 && !locked && (
          <span className="learn-card__elapsed" style={{ width: `${Math.min(100, progress)}%` }} />
        )}

        {hasVideoChat(video) && (
          <span className="learn-card__bot" title="This video answers questions">
            <img src={chatrobo} alt="" />
          </span>
        )}

        {locked ? (
          <span className="learn-card__lock">
            <LockOutlinedIcon sx={{ fontSize: 18 }} />
            {/* `unlockWith` is `products` minus anything retired, set by Home.
                A video whose every plugin is gone says so rather than pointing
                at a store page that cannot sell. */}
            {unlockWith.length > 0 ? (
              <>
                <span className="ps-label ps-label--dim">Unlock with</span>
                <span className="ps-label" style={{ color: 'var(--ps-text-2)' }}>
                  {unlockWith.join(' · ')}
                </span>
              </>
            ) : (
              <span className="ps-label ps-label--dim">No longer for sale</span>
            )}
          </span>
        ) : (
          <span className="learn-card__play">
            <PlayArrowIcon sx={{ fontSize: 24 }} />
          </span>
        )}
      </div>
    </button>
  );
}

export default VideoCard;
